import React, { useState, useEffect } from 'react';

const AdminLiveReviews = () => {
  const [reviews, setReviews] = useState({ live: [], pending: [], rejected: [] });
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('live');
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const fetchReviews = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch('/api/reviews/admin/live', {
        headers: { 'Authorization': 'Bearer ' + token }
      });
      const data = await res.json();
      if (data.live) setReviews(data);
    } catch (e) { console.error('Failed to fetch reviews:', e); }
    setLoading(false);
  };

  useEffect(() => { fetchReviews(); }, []);

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch('/api/reviews/admin/delete/' + id, {
        method: 'DELETE',
        headers: { 'Authorization': 'Bearer ' + token }
      });
      if (res.ok) {
        setDeleteConfirm(null);
        fetchReviews();
      }
    } catch (e) { console.error('Delete failed:', e); }
  };

  const currentReviews = filter === 'live' ? reviews.live : filter === 'pending' ? reviews.pending : reviews.rejected;
  const stars = (n) => '★'.repeat(n) + '☆'.repeat(5 - n);

  if (loading) return (
    <div style={{padding:'20px',textAlign:'center',color:'#94a3b8'}}>Loading reviews...</div>
  );

  return (
    <div style={{position:'relative'}}>
      {/* Filter Tabs */}
      <div style={{display:'flex',gap:'8px',marginBottom:'16px',flexWrap:'wrap'}}>
        {[
          { key: 'live', label: '🟢 Live', count: reviews.live?.length || 0 },
          { key: 'pending', label: '🟡 Pending', count: reviews.pending?.length || 0 },
          { key: 'rejected', label: '🔴 Rejected', count: reviews.rejected?.length || 0 }
        ].map(tab => (
          <button key={tab.key} onClick={() => setFilter(tab.key)} style={{
            padding:'8px 16px',borderRadius:'20px',border:'none',cursor:'pointer',fontSize:'13px',fontWeight:'700',
            background: filter === tab.key ? 'linear-gradient(135deg,#8b5cf6,#06b6d4)' : 'rgba(255,255,255,0.06)',
            color: filter === tab.key ? '#fff' : '#94a3b8',
            transition:'all 0.2s'
          }}>
            {tab.label} ({tab.count})
          </button>
        ))}
      </div>

      {/* Reviews List */}
      {currentReviews.length === 0 ? (
        <div style={{textAlign:'center',padding:'30px',color:'#64748b',fontSize:'14px'}}>
          No {filter} reviews yet
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:'12px',maxHeight:'400px',overflowY:'auto',paddingRight:'4px'}}>
          {currentReviews.map(review => (
            <div key={review.id} style={{
              padding:'14px',background:'rgba(255,255,255,0.04)',borderRadius:'12px',
              border:'1px solid rgba(255,255,255,0.08)',position:'relative',
              transition:'all 0.2s'
            }}>
              {/* Header */}
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'8px',flexWrap:'wrap',gap:'8px'}}>
                <div style={{display:'flex',alignItems:'center',gap:'10px',minWidth:0}}>
                  <div style={{width:'36px',height:'36px',borderRadius:'50%',background:'linear-gradient(135deg,#8b5cf6,#06b6d4)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',fontWeight:'800',color:'#fff',flexShrink:0}}>
                    {(review.name || '?')[0].toUpperCase()}
                  </div>
                  <div style={{minWidth:0}}>
                    <div style={{color:'#fff',fontWeight:'700',fontSize:'14px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{review.name}</div>
                    <div style={{color:'#64748b',fontSize:'11px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{review.email} • {review.role}</div>
                  </div>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:'8px',flexShrink:0}}>
                  <span style={{color:'#eab308',fontSize:'13px',letterSpacing:'1px'}}>{stars(review.rating)}</span>
                  {deleteConfirm === review.id ? (
                    <div style={{display:'flex',gap:'4px'}}>
                      <button onClick={() => handleDelete(review.id)} style={{padding:'4px 10px',borderRadius:'6px',border:'none',background:'#ef4444',color:'#fff',fontSize:'11px',fontWeight:'700',cursor:'pointer'}}>Confirm</button>
                      <button onClick={() => setDeleteConfirm(null)} style={{padding:'4px 10px',borderRadius:'6px',border:'1px solid rgba(255,255,255,0.1)',background:'transparent',color:'#94a3b8',fontSize:'11px',cursor:'pointer'}}>Cancel</button>
                    </div>
                  ) : (
                    <button onClick={() => setDeleteConfirm(review.id)} style={{padding:'4px 8px',borderRadius:'6px',border:'1px solid rgba(239,68,68,0.3)',background:'rgba(239,68,68,0.1)',color:'#ef4444',fontSize:'11px',fontWeight:'600',cursor:'pointer',transition:'all 0.2s'}}
                      onMouseEnter={e => { e.target.style.background='rgba(239,68,68,0.2)'; }}
                      onMouseLeave={e => { e.target.style.background='rgba(239,68,68,0.1)'; }}
                    >🗑️</button>
                  )}
                </div>
              </div>
              {/* Review Text */}
              <p style={{color:'#cbd5e1',fontSize:'13px',lineHeight:'1.5',margin:'0 0 6px 0',wordBreak:'break-word'}}>"{review.text}"</p>
              {/* Footer */}
              <div style={{color:'#475569',fontSize:'11px'}}>
                {new Date(review.submittedAt).toLocaleDateString('en-GB', { day:'numeric',month:'short',year:'numeric' })}
                {review.moderatedAt && (' • Approved ' + new Date(review.moderatedAt).toLocaleDateString('en-GB', { day:'numeric',month:'short',year:'numeric' }))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Summary Bar */}
      <div style={{marginTop:'12px',padding:'10px 14px',background:'rgba(99,102,241,0.08)',borderRadius:'10px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'8px'}}>
        <span style={{color:'#94a3b8',fontSize:'12px',fontWeight:'600'}}>
          Total: {(reviews.live?.length || 0) + (reviews.pending?.length || 0) + (reviews.rejected?.length || 0)} reviews
        </span>
        <span style={{color:'#64748b',fontSize:'11px'}}>
          Avg rating: {reviews.live?.length ? (reviews.live.reduce((a,r) => a + r.rating, 0) / reviews.live.length).toFixed(1) : 'N/A'} ★
        </span>
      </div>
    </div>
  );
};

export default AdminLiveReviews;
